export default "__VITE_ASSET__39d03c70__"